import { http, pHttp, buildParams } from "./http";

export const signIn = (dto: any) => 
  http.post<any, any>(`/users/signin`, dto)

export const signUp = (dto: any) => 
  http.post<any, any>(`/users/signup`, dto)

export const getAdminAccount = () => 
  http.get<any, any>(`/users/account`)

export const updateAdminAccount = (dto: any) => 
  http.put<any, any>(`/users/account`, dto)

export const getUsers = (params: any) => 
  http.get<any, any>(`/users/list${buildParams(params)}`)

export const getAllUsers = (dto: any) => 
  http.get<any, any>(`/users/list/all`, dto)

export const getLostedUsers = (dto: any) => 
  http.get<any, any>(`/users/list/losted`, dto)

export const findTicket = (data: string) => 
  http.post<any, any>(`/users/find`, {data})

export const getTicket = (id: number) => 
  http.get<any, any>(`/users/ticket/${id}`)

export const updateUser = (id: number, dto: any) => 
  http.put<any, any>(`/users/account/${id}`, dto)

export const deleteUser = (id: number) => 
  http.delete<any, any>(`/users/account/${id}`)

export const sendTicket = (id: number) => 
  http.post<any, any>(`/users/account/${id}/ticket`)

export const getJournal = (query: any) => 
  http.get<any, any>(`/users/journal/${buildParams(query)}`)

export const getUserJournal = (user_id: number, query: any) => 
  http.get<any, any>(`/users/journal/${user_id}${buildParams(query)}`)

// LOYALTY ONLY

export const makePayment = (dto: any) => 
  http.post<any, any>(`/loyalty/cloudpayments/create`, dto)

export const getAccountById = (id: number) => 
  http.get<any, any>(`/loyalty/account/byid/${id}`)

export const getMyWallets = () => 
  http.get<any, any>(`/loyalty/wallets`)

export const createWallet = (dto: any) => 
  http.post<any, any>(`/loyalty/wallets`, dto)

export const deleteWallet = (id: number) => 
  http.delete<any, any>(`/loyalty/wallets/${id}`)

export const selectWallet = (id: number) => 
  http.put<any, any>(`/loyalty/wallets/${id}`)


export const getReferalBonus = (bonus: number, random: number) => 
  http.post<any, any>(`/loyalty/bonus_ref?bonus=${bonus}&random=${random}`)

export const openChest = (line: number) => 
  http.post<any, any>(`/loyalty/open_chest?line=${line}`)

export const getBarbersTop = () => 
  http.get<any, any>(`/loyalty/top/barbers`)

export const getReferalPrize = () => 
  http.post<any, any>(`/loyalty/account/referal/prize`, {})

export const signInWithTelegram = (dto: any) => 
  http.post<any, any>(`/loyalty/signin_tgx`, dto)

export const getClients = (query: any) => 
  http.get<any, any>(`/loyalty/clients${buildParams(query)}`)

export const getClientById = (id: number) => 
  http.get<any, any>(`/loyalty/clients/${id}`)

export const createOrderReview = (dto: any) => 
  http.post<any, any>(`/loyalty/orders/review`, dto)

export const updateOrderReview = (id: number, dto: any) => 
  http.put<any, any>(`/loyalty/orders/review/${id}`, dto)

export const deleteOrderReview = (id: number) => 
  http.delete<any, any>(`/loyalty/orders/review/${id}`)

export const adjustBalance = (id: number, dto: {
    phone: string
    adjust: {
      amountDelta: number
      expirationPeriodDays: number
      comment: string
      notify: boolean
    }
  }) => 
  http.post<any, any>(`/loyalty/account/${id}/adjust`, dto)

export const checkAccount = (dto: any) => 
  http.post<any, any>(`/loyalty/auth/check_sign`, dto)

export const signInWithCode = (dto: any) => 
  http.post<any, any>(`/loyalty/auth/code`, dto)

export const signUpWithMaxma = (dto: any) => 
  http.post<any, any>(`/loyalty/auth/signup`, dto)

export const getAccount = () => 
  http.get<any, any>(`/loyalty/account`)

export const getAccountBonusHistory = () => 
  http.get<any, any>(`/loyalty/account/bonus_history`)

export const getAccountNewBonuses = () => 
  http.get<any, any>(`/loyalty/account/bonx`)

export const updateAccount = (id: number, dto: any) => 
  http.put<any, any>(`/loyalty/account`, dto)

export const deleteAccount = (id: number) => 
  http.delete<any, any>(`/loyalty/account/${id}`)

export const adjusterAction = (dto: any) => 
  http.post<any, any>(`/loyalty/adjuster`, dto)

export const getFavs = () => 
  http.get<any, any>(`/loyalty/favorites`)

export const createFav = (dto: any) => 
  http.post<any, any>(`/loyalty/favorites`, dto)

export const updateFav = (id: number, dto: any) => 
  http.put<any, any>(`/loyalty/favorites/${id}`, dto)

export const deleteFav = (id: number) => 
  http.delete<any, any>(`/loyalty/favorites/${id}`)


export const getWishes = () => 
  http.get<any, any>(`/loyalty/wishes_all`)

export const getMyWishes = () => 
  http.get<any, any>(`/loyalty/wishes`)

export const createWish = (dto: any) => 
  http.post<any, any>(`/loyalty/wishes`, dto)

export const updateWish = (id: number, dto: any) => 
  http.put<any, any>(`/loyalty/wishes/${id}`, dto)

export const deleteWish = (id: number) => 
  http.delete<any, any>(`/loyalty/wishes/${id}`)

export const getMyStatus = () =>
  http.get<any, any>(`/loyalty/statuses/my`)

export const selectPrizeForStatus = (dto: any) => 
  http.post<any, any>(`/loyalty/statuses/gift`, dto)
